<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  task: { type: Object, required: true },
  agents: { type: Array, required: true },
});

const emit = defineEmits(['change']);

const { t } = useI18n();
const isOpen = ref(false);

// DropdownMenu rejects a falsy value, so "nobody" needs a value of its own.
const NOBODY = 'none';

const menuItems = computed(() => [
  {
    label: t('CARDS.TASKS.UNASSIGNED'),
    value: NOBODY,
    action: 'assignee',
    isSelected: !props.task.assignee,
  },
  ...props.agents.map(agent => ({
    label: agent.name,
    value: String(agent.id),
    action: 'assignee',
    thumbnail: { name: agent.name, src: agent.thumbnail },
    isSelected: agent.id === props.task.assignee?.id,
  })),
]);

const onAction = ({ value }) => {
  isOpen.value = false;
  emit('change', value === NOBODY ? null : Number(value));
};
</script>

<template>
  <div v-on-clickaway="() => (isOpen = false)" class="relative flex-shrink-0">
    <button
      type="button"
      class="grid rounded-full size-6 place-content-center text-n-slate-10 hover:bg-n-alpha-2"
      :title="task.assignee?.name || $t('CARDS.TASKS.UNASSIGNED')"
      data-testid="task-assignee"
      @click="isOpen = !isOpen"
    >
      <Avatar
        v-if="task.assignee"
        :name="task.assignee.name"
        :src="task.assignee.thumbnail"
        :size="20"
        rounded-full
      />
      <span v-else class="i-lucide-user-round-plus size-4" />
    </button>
    <DropdownMenu
      v-if="isOpen"
      :menu-items="menuItems"
      class="z-50 w-56 mt-1 top-full ltr:right-0 rtl:left-0"
      @action="onAction"
    />
  </div>
</template>
